import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const RENEWAL_SCHEMA = Object.freeze({
  NEXT_RENEWAL_PRICE: 0, // subunit
  NEXT_RENEWAL_DATE: '',
  RENEWAL_FULL_PRICE: 0, // subunit
  RENEWAL_CURRENCY: 'USD',
});
const RECORD = generateSchema(RENEWAL_SCHEMA);
const KEYS: any = generateKeys(RENEWAL_SCHEMA);

export class Renewal extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  /**
   * Next cycle renewal price.
   * It has lower amount than full price if promo/discount applied
   * @return subunit
   */
  get nextRenewalPrice(): number {
    return this.get(KEYS.NEXT_RENEWAL_PRICE);
  }

  get nextRenewalDate(): string {
    return this.get(KEYS.NEXT_RENEWAL_DATE);
  }

  /**
   * Renewal full price
   * @return subunit
   */
  get renewalFullPrice(): number {
    return this.get(KEYS.RENEWAL_FULL_PRICE);
  }

  get renewalCurrency(): string {
    return this.get(KEYS.RENEWAL_CURRENCY);
  }

  hasPromoPrice(): boolean {
    return this.nextRenewalPrice < this.renewalFullPrice;
  }
}
